
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import StandardModal from '@/components/shared/suites/StandardModal.vue';
import SelectComponent from '@/components/shared/Select.vue';
import CustomQuestionsList from '@/components/advanced/custom-questions/CustomQuestionsList.vue';

@Component<CustomQuestionsModal>({
	components: {
		StandardModal,
		SelectComponent,
		CustomQuestionsList
	}
})
export default class CustomQuestionsModal extends Vue {
	@Getter('getRestaurant', { namespace: 'auth' }) private restaurant!: Restaurant;
	@Prop({ type: Array, required: true }) private questions!: CustomQuestion[];
	@Prop({ type: String, required: true }) private type!: CustomQuestionCategoryType;
	@Prop({ type: Boolean, required: true, default: false }) private showModal!: boolean;

	private isEditing: boolean = false;
	private selectedLocale: RestaurantLocale = {} as RestaurantLocale;

	private get isDefaultLocale(): boolean {
		return !this.selectedLocale || !Object.keys(this.selectedLocale).length || (this.selectedLocale && this.selectedLocale.is_default);
	}

	private created(): void {
		this.setLocaleToDefault();
	}

	/**
	 * Switch to default locale
	 *
	 * @return {void}
	 */
	private setLocaleToDefault(): void {
		if (this.restaurant.locales?.length > 1) {
			this.selectedLocale = this.restaurant.locales.find((locale: RestaurantLocale) => locale.is_default)!;
		}
	}

	/**
	 * Emit event to close modal
	 *
	 * @return {void}
	 */
	private closeModal(): void {
		this.$emit('close');
	}
}
